<template>
  <div class="document-title-company">
    <div class="document-title text-textDarkest">
      {{ title }}
    </div>
    <div class="document-company-badges">
      <div class="document-company">
        {{ company }}
      </div>
      <JobBadgesCombined
        v-if="(isExternal === false) || (isEvergreen === true)"
        :is-internal="isExternal === false"
        :is-evergreen="isEvergreen === true "
      />
      <JobBadgeNonEnglish v-if="isNonEnglish" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import JobBadgesCombined from '@/components/editor/badge/JobBadgesCombined.vue';
import JobBadgeNonEnglish from '@/components/editor/badge/JobBadgeNonEnglish.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  company: {
    type: String,
    default: '',
  },
  isExternal: {
    type: Boolean,
    default: true,
  },
  isEvergreen: {
    type: Boolean,
    default: false,
  },
  languageCode: {
    type: String,
    default: null,
  },
});

const isNonEnglish = computed(() => Boolean(props.languageCode) && props.languageCode !== 'en');
</script>

<style lang="less" scoped>
.document-title-company {
  max-width: 100%;
  overflow: hidden;
}

.document-title {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-company-badges {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
}

.document-company {
  font-weight: 500;
  font-size: 13px;
  text-align: left;
  line-height: 150%;
}
</style>
